const navy10 = "#fdfdff";
const navy25 = "#f4f4f7";
const navy50 = "#e4e6ee";
const navy75 = "#cdcfda";
const navy100 = "#b8baca";
const navy200 = "#9599b0";
const navy300 = "#656b8c";
const navy400 = "#474e75";
const navy500 = "#192253";
const navy600 = "#171f4c";
const navy700 = "#12183b";
const navy800 = "#0e132e";
const navy900 = "#0b0e23";
const navys = {
  navy10,
  navy25,
  navy50,
  navy75,
  navy100,
  navy200,
  navy300,
  navy400,
  navy500,
  navy600,
  navy700,
  navy800,
  navy900
};
export {
  navys as default,
  navy10,
  navy100,
  navy200,
  navy25,
  navy300,
  navy400,
  navy50,
  navy500,
  navy600,
  navy700,
  navy75,
  navy800,
  navy900
};
//# sourceMappingURL=index.es7.js.map
